import styled from "styled-components";

import * as UI from "../../../../../../modules/ui-kit";
import PropertiesOverview from "../../form/Components/PropertiesOverview";
import ComponentTypeCardContainer from "../component-type/ComponentTypeCardContainer";

export default function LayerCard(props) {
    const {
        bimClassID,
        componentTypeID,
        index,
        onCopy,
        onEdit,
        onMoveDown,
        onMoveUp,
        onRemove,
        properties,
    } = props;
    return (
        <Styled>
            <span>Layer { index + 1 }</span>
            <ComponentTypeCardContainer
                bimClassID={ bimClassID }
                id={ componentTypeID }
            />
            {
                properties && (
                    <PropertiesOverview
                        className="properties"
                        properties={ properties }
                    />
                )
            }
            <div className="buttons">
                <UI.Button
                    disabled={ !onMoveUp }
                    onClick={ onMoveUp }
                >
                    Move up
                </UI.Button>
                <UI.Button
                    disabled={ !onMoveDown }
                    onClick={ onMoveDown }
                >
                    Move down
                </UI.Button>
            </div>
            <div className="buttons">
                <UI.Button
                    onClick={ onEdit }
                >
                    Change
                </UI.Button>
                <UI.Button
                    onClick={ onRemove }
                >
                    Remove
                </UI.Button>
                <UI.Button
                    onClick={
                        () => onCopy(
                            {
                                properties,
                                componentType: { id: componentTypeID },
                            }
                        )
                    }
                >
                    Duplicate
                </UI.Button>
            </div>
        </Styled>
    );
}

const Styled = styled.div`
    background: #6661;
    border-radius: 4px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: min-content min-content min-content;
    padding: 8px 16px;
    transition: 200ms;

    & > .properties {
        grid-column: 1 / -1;
    }

    & > .buttons {
        display: flex;
        flex-direction: row;
        gap: 4px;

        &:last-of-type {
            justify-content: flex-end;
        }
    }
`;
